export default __webpack_public_path__ + "static/media/iq-img1-w.87c5d176.png";